module.exports = __webpack_public_path__ + "static/assets/f3f1fdadce476f89202e4c5f385c5a45.svg";